import React, { useState, useEffect, useCallback } from 'react';

// ============================================================================
// DENEMELER (Satış Arşivi sekmesi, 2026-10-09, kullanıcı kararı). Okul kapaklı her PDF
// indirme / yazdırma bir deneme kaydı yazar (kapaktaki karekod = /api/deneme/<kod>).
// Karekod sayfası herkese açıktır ama cevap anahtarı yalnız burada "Anahtarı yayınla"
// denince açılır (öğrenci sınav sırasında okutsa da görmez). Satırı açınca anahtar
// public_no ile görünür. Kayıtlar silinmez.
// ============================================================================
const tarih = (z) => (z ? new Date(z).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

function sinavAdi(o = {}) {
  const k = o.kanit || {};
  if (o.sinavAdi) return `${o.sinavAdi}${k.sinif ? ` · ${k.sinif}. sınıf` : ''}`;
  if (o.kapakTur === 'kanit') {
    return `Öğrenme Kanıtı Sınavı${Number(k.uygulama) > 0 ? ` ${k.uygulama}` : ''}${k.sinif ? ` · ${k.sinif}. sınıf` : ''}`;
  }
  return o.kapakTur === 'genel' ? 'Genel Deneme' : 'Konu Testi';
}

export default function DenemeListesi({ apiUrl, authFetch }) {
  const [liste, setListe] = useState(null);
  const [hata, setHata] = useState('');
  const [acik, setAcik] = useState(null);
  const [bekleyen, setBekleyen] = useState(null);

  const yukle = useCallback(async () => {
    setHata('');
    try {
      const d = await (await authFetch(`${apiUrl}/api/deneme`)).json();
      if (!d || !d.basarili) throw new Error((d && d.hata) || 'Liste alınamadı');
      setListe(d.denemeler || []);
    } catch (e) {
      setHata(e.message || 'Hata');
      setListe([]);
    }
  }, [apiUrl, authFetch]);

  useEffect(() => { yukle(); }, [yukle]);

  const yayinla = async (kod, yayinda) => {
    setBekleyen(kod); setHata('');
    try {
      const d = await (await authFetch(`${apiUrl}/api/deneme/${kod}`, {
        method: 'PATCH', body: JSON.stringify({ anahtar_yayinda: yayinda }),
      })).json();
      if (!d || !d.basarili) throw new Error((d && d.hata) || 'Güncellenemedi');
      setListe((l) => l.map((x) => (x.kod === kod ? { ...x, ...d.deneme } : x)));
    } catch (e) {
      setHata(e.message || 'Hata');
    }
    setBekleyen(null);
  };

  if (liste === null) return <div className="text-sm text-gray-500 p-3">Yükleniyor…</div>;
  return (
    <div data-deneme-listesi>
      {hata && <div className="mb-3 p-3 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm">{hata}</div>}
      <p className="text-xs text-gray-500 mb-2">
        Okul kapaklı her PDF bir deneme kaydı yazar; kapaktaki karekod bu kaydın sayfasını açar. Cevap anahtarı
        karekod sayfasında yalnız “Anahtarı yayınla” denince görünür.
      </p>
      {liste.length === 0 ? (
        <div className="text-sm text-gray-500 p-3 bg-white border rounded-lg">Henüz deneme kaydı yok.</div>
      ) : (
        <div className="overflow-x-auto bg-white border border-gray-200 rounded-xl">
          <table className="w-full text-xs">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="text-left px-3 py-2 font-semibold">Kod</th>
                <th className="text-left px-3 py-2 font-semibold">Okul</th>
                <th className="text-left px-3 py-2 font-semibold">Sınav</th>
                <th className="text-left px-3 py-2 font-semibold">Kitapçık</th>
                <th className="text-left px-3 py-2 font-semibold">Durum</th>
                <th className="text-left px-3 py-2 font-semibold">Güncelleme</th>
                <th className="text-left px-3 py-2 font-semibold">Cevap anahtarı</th>
              </tr>
            </thead>
            <tbody>
              {liste.map((d) => {
                const turler = Object.keys(d.kitapciklar || {}).sort();
                return (
                  <React.Fragment key={d.kod}>
                    <tr data-deneme={d.kod} className="border-t border-gray-100 align-top">
                      <td className="px-3 py-2 font-mono">
                        <button type="button" className="underline" onClick={() => setAcik(acik === d.kod ? null : d.kod)}
                          title="Cevap anahtarını göster / gizle">{d.kod_gosterim || d.kod}</button>
                        {' '}<a href={d.url} target="_blank" rel="noreferrer" title="Karekod sayfası">↗</a>
                      </td>
                      <td className="px-3 py-2">{d.okul_ad || (d.ozet && d.ozet.kurum) || '—'}</td>
                      <td className="px-3 py-2">{sinavAdi(d.ozet)} · {(d.ozet && d.ozet.soru_sayisi) || 0} soru</td>
                      <td className="px-3 py-2">{turler.join(', ') || '—'}</td>
                      <td className="px-3 py-2">{d.alici_ad ? `Satıldı: ${d.alici_ad}` : 'Deneme baskısı'}</td>
                      <td className="px-3 py-2">{tarih(d.guncelleme)}</td>
                      <td className="px-3 py-2">
                        <button type="button" data-anahtar-yayinla={d.kod} disabled={bekleyen === d.kod}
                          onClick={() => yayinla(d.kod, !d.anahtar_yayinda)}
                          className={`px-2 py-1 rounded-lg border text-[11px] font-semibold ${d.anahtar_yayinda
                            ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-700 border-gray-300'}`}>
                          {d.anahtar_yayinda ? '✓ Yayında · geri al' : 'Anahtarı yayınla'}
                        </button>
                      </td>
                    </tr>
                    {acik === d.kod && (
                      <tr className="bg-gray-50"><td colSpan={7} className="px-3 py-2">
                        {turler.map((t) => (
                          <div key={t} className="mb-2">
                            <div className="font-semibold mb-1">{t} kitapçığı</div>
                            <div className="flex flex-wrap gap-1">
                              {((d.kitapciklar[t] || {}).anahtar || []).map((s, i) => (
                                <span key={i} className="px-1.5 py-0.5 border rounded bg-white"
                                  title={s.test || ''}>{s.no}-{s.cevap || '?'} <span className="text-gray-400">#{s.public_no}</span></span>
                              ))}
                            </div>
                          </div>
                        ))}
                      </td></tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
